import { Edge, Node } from '@xyflow/react';
import { EDataType } from 'src/modules/network-configuration/models/node-data';
import { NodeModel } from 'src/modules/network-configuration/models/node-model';
import { getPortIdFromHandle } from 'src/modules/network-configuration/models/node-utils';

/** Human-readable lines: which switch port(s) this device uses. */
export function getDeviceSwitchConnectionLines(
  deviceId: string,
  edges: Edge[],
  nodes: Node<NodeModel>[],
): string[] {
  const byId = new Map(nodes.map((n) => [n.id, n]));

  return edges
    .filter((e) => e.source === deviceId || e.target === deviceId)
    .map((edge) => {
      const otherId = edge.source === deviceId ? edge.target : edge.source;
      const other = byId.get(otherId);
      const otherCat = other?.data?.category;
      if (!otherCat) return null;

      const deviceHandle =
        edge.source === deviceId ? edge.sourceHandle : edge.targetHandle;
      const peerHandle =
        edge.source === deviceId ? edge.targetHandle : edge.sourceHandle;

      if (otherCat.type === EDataType.Switch) {
        const port = getPortIdFromHandle(peerHandle || '') || '?';
        return `${otherCat.name} — ${port}`;
      }
      const port = getPortIdFromHandle(deviceHandle || '') || '?';
      return `Peer "${otherCat.name}" (${otherId}) — local port ${port}`;
    })
    .filter((line): line is string => line != null);
}
